<template>
  <teleport to="body">
    <div class="modal" v-if="showModal" @click.self.prevent="showModal != showModal">
      <div class="wrapper">
        <div class="content">
          <font-awesome-icon icon="fa-xmark" class="exit" @click="showModal = false" size="sm" />
          <h3>Companion Control</h3>
          <form @submit.prevent.stop="submit">
            <div class="name">
              <h3>Station Name: {{ station.name }}</h3>
            </div>
          </form>
          <CodeLogIn :station="station.name" :site="station.site" />
          <button class="btn" @click.stop.prevent="logoutCompanion">Log Companion Out</button>
        </div>
      </div>
    </div>
  </teleport>
</template>
<script>
//   import { api } from "@/helpers/api";
import { mapGetters } from "vuex";
import { CodeLogIn } from "@monolith/components";

export default {
  name: "companionModal",
  props: ["open", "station"],
  // emits: ["update"],
  components: {
    CodeLogIn,
  },
  data() {
    return {
      showModal: false,
      categories: [],
      openStations: null,
      channel: null,
    };
  },
  methods: {
    updateTimer(timer) {
      this.$emit("update-timer", timer);
    },

    logoutCompanion() {
      // CHANNEL CHANGE - companion:logout and bridge:companion:logout
      if (process.env.VUE_APP_FEATURE_FLAGS == "pos") {
        this.channel.push("companion:logout");
        this.showModal = !this.showModal;
      } else {
        this.channel.push("bridge:companion:logout", this.station.name);
      }
    },

    async deleteStation() {
      this.$emit("update", "delete", "kds", this.openStation);
    },
  },
  computed: {
    ...mapGetters({
      siteMap: "siteMap",
      siteSettings: "siteSettings",
    }),
  },
  watch: {
    async open() {
      this.showModal = true;
      this.openStation = this.station;

      // this.categories = await api.get("/api/categories/get/" + window.localStorage.getItem("company") + "/" + this.station.site, "?include_docs=false");
    },
  },
};
</script>
<style scoped lang="scss">
@use "@monolith/styles";

h3 {
  color: var(--text-colour);
  text-align: center;
  margin: 0.5rem;
}

.active {
  color: var(--action-colour);
}

.discon {
  color: var(--warning-colour);
}

.delete {
  background: var(--warning-colour);
  color: var(--text-colour);
}
form {
  .name {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    gap: 1rem;
    margin: 1rem;
    h4,
    input {
      margin: 0 !important;
      border-radius: 0.25rem;
    }
  }
  .action-btns {
    display: flex;
    flex-direction: row;
    justify-content: space-evenly;
    margin: 0 auto;
  }
}

.btn {
  background-color: var(--action-colour);
  color: var(--secondary-text-colour);
  margin: 0.5rem;
}
.status {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  margin: 1rem;
}
</style>
